import React from 'react';
import { useNotification } from './NotificationContext';
import Notification from './Notification';

const NotificationContainer = () => {
    const { notifications, removeNotification } = useNotification();

    // 🔥 NOUVEAU : Plus besoin de cacher les notifications en fullscreen
    // car exitFullscreen() est maintenant appelé automatiquement dans NotificationContext !

    return (
        // ⚡ z-[99999] pour être AU-DESSUS de tout
        <div className="fixed top-4 right-4 z-[99999] flex flex-col gap-3 pointer-events-none max-w-full">
            <div className="flex flex-col gap-3 pointer-events-auto">
                {notifications.map((notification) => (
                    <Notification
                        key={notification.id}
                        notification={notification}
                        onClose={removeNotification}
                    />
                ))}
            </div>
        </div>
    );
};

export default NotificationContainer;